import { z } from 'zod';

import { PaymentId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UsioMarkAsFailedEvent = BaseLoanEvent.extend({
  type: z.literal('usioMarkAsFailed'),
  paymentId: PaymentId,
  failureCode: z.string(),
});
export type UsioMarkAsFailedEvent = z.infer<typeof UsioMarkAsFailedEvent>;
